import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { isEqual } from '../../contexts/Utils';
import { Badge, Button, Empty, Input, Popover } from 'antd';
import { routes } from '../../router/routes';
import { CiSearch } from 'react-icons/ci';
import { LuCommand } from 'react-icons/lu';
import { RiNotification3Line } from 'react-icons/ri';
import SideBar from '../../components/SideBar';
import MenuBar from '../../components/MenuBar';
import { useGetProfile, useGetUnitDetails } from '../../hooks/settings.hook';

type Props = {
  children: React.ReactComponentElement<never> | React.ReactElement;
};
const MainLayout = ({ children }: Props) => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMobile, setIsOpenMobile] = useState(false);
  const onCloseMobile = () => setIsOpenMobile(false);
  const onOpenMobile = () => setIsOpenMobile(true);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);

  const path = routes.find(({ path }) => isEqual(path, pathname));

  const Notification = () => (
    <div className="bg-white p-5">
      <Empty />
    </div>
  );

  // get logged in users and unit profile 
  useGetUnitDetails()
  useGetProfile()
  return (
    <div className="w-full h-screen flex">
      <SideBar isOpen={isOpen} isOpenMobile={isOpenMobile} onClose={onClose} onCloseMobile={onCloseMobile} onOpen={onOpen} onOpenMobile={onOpenMobile} />
      <div className="w-full h-full overflow-y-auto scrollbar-thin">
        <div className="w-full sticky top-0 bg-white border-b border-outline flex justify-between items-center p-3 px-5 md:px-10 z-20">
          <div className="">
            <p className="text-base md:text-lg font-normal text-secondary">{path?.label}</p>
            <p className="text-xs md:text-sm font-normal text-gray">{path?.description}</p>
          </div>
          <div className="flex items-center gap-5">
            <Input
              allowClear
              size="large"
              placeholder="Search"
              prefix={<CiSearch />}
              className="!rounded-xl hidden"
              suffix={<Button className="bg-lit" size="small" icon={<LuCommand />}>K</Button>}
            />
            <Popover content={<Notification />}>
              <Badge dot>
                <RiNotification3Line className="!text-xl" />
              </Badge>
            </Popover>
          </div>
        </div>
        <div className="w-full p-5 md:px-10 pb-20 md:pb-5">{children}</div>
      </div>
      <MenuBar openMenu={onOpenMobile} />
    </div>
  );
};

export default MainLayout;
